import { Outlet } from "react-router-dom";

import { useHtmlLang } from "@/lib/useHtmlLang";

import { AppNav } from "./AppNav";

/**
 * Layout wrapper for the authenticated app pages: the shared {@link AppNav}
 * (Scheda brand + primary nav + signed-in header) pinned on top, with the
 * matched route rendered below it. Used as a react-router layout route so
 * every inner page gets one consistent header without hand-rolling its own.
 *
 * Each page keeps its own content wrapper (max-width, padding) as the Outlet
 * child; this only owns the full-bleed background + the nav.
 */
export function AppShell() {
  // The interior is hardcoded English; say so, so Chrome stops offering to
  // translate it. See useHtmlLang for the full story.
  useHtmlLang("en");

  return (
    /* translate="no" is load-bearing, not decoration: browser translators
       (Google Translate, and extensions that do the same) swap React-owned text
       nodes for their own <font> wrappers as content scrolls into view. React
       then tries to remove a node whose parent it no longer owns and the whole
       page dies with "NotFoundError: Failed to execute 'removeChild' on 'Node'".
       Nothing in here is localized yet, so there is nothing to lose by opting
       out — the landing, sign-in and legal pages stay translatable. */
    <div className="min-h-screen bg-background" translate="no">
      <AppNav />
      <Outlet />
    </div>
  );
}
